import { Environment, StorageFactory } from "common247";
import { FirebaseServices } from "./firebase/config";

// TOO:JJ AAARRGGG - Is there a better way to have a global "firebase" setup? Check out the Store slices - how do we pass in the "active FirebaseSetup" to those functions nicely?
let fb: FirebaseServices | undefined;

export type AppConfig = {
  environ: Environment;
  appVersion: string;
  productVersion: string;
  domain: string;
};
let config: AppConfig | undefined;

export function getGlobalFirebase(): FirebaseServices {
  if (fb === undefined) throw Error("Must initialise Firebase first!");
  return fb;
}

export function setGlobalFirebase(setup: FirebaseServices): void {
  fb = setup;
}

// TODO:JJ - Call firebase function to get this!
export function getStorageFactory(): StorageFactory | undefined {
  //TODO!!!
  return undefined; // firebaseImages;
  // if (useEmulators) {
  //   return firebaseImages; // TODO: Hardcode UAT for ALL urls! // mulatorFirebaseImages;
  // } else {
  //   return firebaseImages; // TODO: Hardcode UAT for ALL urls!
  // }
}

// TODO: Temp place to keep this - BUT move to Context/Provider!!!
// And maybe just put the spinner asset into "assets" not storage!
// For LoadingSpinner? Include in assets?
export function getSpinnerUrl(): string | undefined {
  return undefined; //getStorageFactory()!.spinnerUrl;
}

export function getAppConfig(): AppConfig {
  if (config === undefined) throw Error("Must initialise Config first!");
  return config;
}

export function setAppConfig(c: AppConfig): void {
  config = c;
}
